import styled, { keyframes } from 'styled-components/macro'
import React from 'react'
import { t } from 'ttag'

const Container = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 0);
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  animation: ${rotate} 2s linear infinite;
  display: inline-block;
`

const Title = styled.span`
  padding-left: 0.5rem;
`

export default function LoadingSpinner({ showText = true }: { showText: boolean }) {
  return (
    <Container>
      <Spinner>
        <i className="fas fa-spinner" />
      </Spinner>
      {showText && <Title>{t`Loading...`}</Title>}
    </Container>
  )
}
